module.exports = __webpack_public_path__ + "officialStatic/img/money2.ad63722.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/money2.png
// module id = AVtO
// module chunks = 0